import { MfeReactComponent } from '@carvana/microfrontend-react';
import { memo } from 'react';
import { QUALI_MODULE } from '../../mfeConfig';

const QualiSurvey = memo(() => (
  <MfeReactComponent component="default" module={QUALI_MODULE}>
    {({ Component: QualiComponent }) => <QualiComponent teamName="stc" />}
  </MfeReactComponent>
));

export default QualiSurvey;
